import { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';

/**
 * OfflineIndicator Component
 * 
 * Shows a notification when the user goes offline/online.
 * Helps users understand when they're using cached content.
 */
export function OfflineIndicator() {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);
    const [showOnlineMessage, setShowOnlineMessage] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOffline(false);
            setShowOnlineMessage(true);
            // Hide online message after 3 seconds
            setTimeout(() => setShowOnlineMessage(false), 3000);
        };

        const handleOffline = () => {
            setIsOffline(true);
            setShowOnlineMessage(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <>
            {/* Offline notification */}
            <Snackbar
                open={isOffline}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    severity="warning"
                    icon={<WifiOffIcon />}
                    sx={{ width: '100%' }}
                >
                    Δεν υπάρχει σύνδεση στο διαδίκτυο
                </Alert>
            </Snackbar>

            {/* Back online notification */}
            <Snackbar
                open={showOnlineMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={3000}
                onClose={() => setShowOnlineMessage(false)}
            >
                <Alert
                    severity="success"
                    icon={<WifiIcon />}
                    sx={{ width: '100%' }}
                >
                    Επανασύνδεση στο διαδίκτυο
                </Alert>
            </Snackbar>
        </>
    );
}

export default OfflineIndicator;
